module.exports = __webpack_public_path__ + "img/case_2.38a04073.png";